import { CmpCheck, isMobile, loadScript } from "../common/utils";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	// Outbrain widget
	let rootMargin = "0px 0px 600px 0px";
	if (!isMobile()) {
		rootMargin = "0px 0px 1000px 0px";
	}
	const outbrainWidget = document.querySelector("#_outbrain_wg div");
	if (outbrainWidget) {
		outbrainWidget.style.minHeight = "200px"; // Ensure the widget has a minimum height to be observed
		const cmp = new CmpCheck();
		cmp.checkConsent().then((response) => {
			if (response) {
				const widgetObserver = new IntersectionObserver(
					(items) => {
						if (items[0].isIntersecting) {
							loadScript(
								"outbrain-js",
								"https://widgets.outbrain.com/outbrain.js",
							);
							widgetObserver.disconnect();
						}
					},
					{
						rootMargin: rootMargin,
					},
				);
				widgetObserver.observe(outbrainWidget);
			}
		});
	}
});
